var $8c2d8eab91e8fc21$exports = {};
$8c2d8eab91e8fc21$exports = {
    "maximum": `Maximum`,
    "minimum": `Minimum`
};


export {$8c2d8eab91e8fc21$exports as default};
//# sourceMappingURL=de-DE.module.js.map
